let installed = false;

export function installBrowserDomGuard(): void {
  if (installed || typeof Node === 'undefined') return;
  installed = true;

  const removeChild = Node.prototype.removeChild;
  const insertBefore = Node.prototype.insertBefore;

  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) return child;
    return removeChild.call(this, child) as T;
  };

  Node.prototype.insertBefore = function <T extends Node>(this: Node, node: T, ref: Node | null): T {
    if (ref && ref.parentNode !== this) return node;
    return insertBefore.call(this, node, ref) as T;
  };
}

export function isBrowserDomNoise(message: string | null | undefined): boolean {
  if (!message) return false;
  return /Failed to execute '(?:removeChild|insertBefore)' on 'Node'/.test(message);
}
